export const productList = [
  {
    tit: "旗舰奢华按摩椅系列",
    img_url: require("@/assets/images/productBann1.png"),
    non: 0,
    themeUrl: require("@/assets/images/home_icon1.png"),
  },
  {
    tit: "时尚简约按摩椅系列",
    img_url: require("@/assets/images/productBann2.png"),
    non: 0,
    themeUrl: require("@/assets/images/home_icon2.png"),
  },
  {
    tit: "超值舒享按摩椅系列",
    img_url: require("@/assets/images/productBann3.png"),
    non: 0,
    themeUrl: require("@/assets/images/home_icon3.png"),
  },
  {
    tit: "8推全功能按摩椅系列",
    img_url: require("@/assets/images/productBann4.png"),
    non: 0,
    themeUrl: require("@/assets/images/home_icon4.png"),
  },
  {
    tit: "眼部按摩器系列",
    img_url: require("@/assets/images/productBann5.png"),
    non: 0,
    themeUrl: require("@/assets/images/home_icon5.png"),
  },
  {
    tit: "小件按摩器系列",
    img_url: require("@/assets/images/productBann6.png"),
    non: 0,
    themeUrl: require("@/assets/images/home_icon6.png"),
  },
];
// index banner
export const bannerList = [
  {
    imgurl: require("@/assets/images/4M880.png"),
    id: 3,
  },
  {
    imgurl: require("@/assets/images/2M610Pro.png"),
    id: 8,
  },
  {
    imgurl: require("@/assets/images/3M810.png"),
    id: 2,
  },
];
// 产品动态
export const activeList = [
  {
    href: "https://news.sina.com.cn/sx/2022-11-14/detail-imqqsmrp6097722.shtml",
    img_url: require("@/assets/images/activePage1.png"),
    title: "摩摩哒 X 成都AG超玩会",
    info: "2022年，摩摩哒“从爱自己的开始”的初衷出发，借着“电竞健康化”的风口，持续关注电竞大健康以及年轻消费者身心健康。",
  },
  {
    href: "https://k.sina.com.cn/article_5601071106_14dd99002001016ivk.html?kdurlshow=1&wm=3049_0047&from=game",
    img_url: require("@/assets/images/activePage2.png"),
    title: "摩摩哒 X 王者荣耀",
    info: "2022年，摩摩哒基于品牌发展战略，联动王者IP，进入年轻人视野，为年轻群体提供健康生活的新方案。",
  },
  {
    href: "http://pingquan.jiaju.sina.com.cn/zixun/q/20220714/6953274609156555924.shtml",
    img_url: require("@/assets/images/activePage3.png"),
    title: "摩摩哒 X 《玩美咖》",
    info: "2022年，潮玩好物节目心动推荐，边玩边美的精彩生活。年轻人解压的最佳选择之一，精致健康生活装备。",
  },
  {
    href: "https://mp.weixin.qq.com/s/ZCy4GSw237imYu5Ms7eoWA",
    img_url: require("@/assets/images/activePage4.png"),
    title: "摩摩哒 X 《给你我的新名片》",
    info: "2021年，综艺内容中植入产品，攻略年轻人社交阵地，传达品牌主张，传达学会爱自己的理念，更懂生活的每一面",
  },
  {
    href: "https://mp.weixin.qq.com/s/9-aHAn9LCI_txk7xDloZoA",
    img_url: require("@/assets/images/activePage5.png"),
    title: "摩摩哒 X 《反贪风暴5》",
    info: "2021年，摩摩哒坚守影院这一理想阵地，为消费者提供优质服务，以最舒服的姿态，欣赏热门影片，愉悦自我，放松身心。",
  },
];
export const activeList2 = [
  {
    img_url: require("@/assets/images/M610.png"),
  },
  {
    img_url: require("@/assets/images/M810.png"),
  },
  {
    img_url: require("@/assets/images/M880-2.png"),
  },
  {
    img_url: require("@/assets/images/M880.png"),
  },
];
// 关于荣泰
export const about = {
  tabNav: [
    {
      title: "荣泰背书",
      id: 1,
    },
    {
      title: "品牌理念",
      id: 2,
    },
    {
      title: "品牌历程",
      id: 3,
    },
    {
      title: "资质荣誉",
      id: 4,
    },
  ],
  developmentHistory: [
    {
      time: "2015年",
      message: "MOMODA摩摩哒品牌诞生。",
    },
    {
      time: "2016年",
      message: "摩摩哒共享按摩椅进入影院、机场、高铁站等场所。",
    },
    {
      time: "2017年",
      message: "联合小米打造推出适合年轻人的智能休闲按摩椅。",
    },
    {
      time: "2018年",
      message:
        "摩摩哒共享按摩椅投放量突破80000台，与万达、保利、金逸等多家院线达成战略合作。",
    },
    {
      time: "2019年",
      message: "摩摩哒眼部按摩器，小米有品众筹突破15000台。",
    },
    {
      time: "2020年",
      message:
        "SX322眼部按摩器累计销售突破80000台；RT5870摩云智能按摩椅累计销售突破12000台。",
    },
    {
      time: "2021年",
      message:
        "摩摩哒家用产品销售突破19万件，618和双十一期间冲劲天猫行业TOP2单品。",
    },
    {
      time: "2022年",
      message: "小米有品单品众筹突破1000万。",
    },
  ],
  Background:
    "摩摩哒（MOMODA），成立于2015年，隶属于荣泰健康科技集团，由上海艾荣达健身科技有限公司运营。依托荣泰集团26年专业技术沉淀，以及同济大学、上海大学、复旦大学、上海中医药大学四大院校科研优势，不断技术升级，带给用户更健康舒适的按摩体验，开发以智能缓压为主线的居家产品设计，通过零售业务及共享按摩椅业务，提供智能按摩护理产品和服务。自创立以来，从共享按摩业务升级发展家用按摩产品业务，网点覆盖全国360+城市，累计服务用户已超过6200万，累计服务人次超1.1亿。",
  ideaContant: {
    slogan: [
      "品牌理念",
      "( 1 ) 摩摩哒，从爱自己开始",
      "( 2 ) 横扫劳累，舒适加倍",
      "品牌愿景",
      "摩摩哒始终致力于让“爱自己”成为一种被鼓励的生活态度，让每一位消费者都能用更智能、更舒适、更温暖的方式，舒缓压力，关爱自己，关爱他人，开启健康生活；让表达关心和爱的方式，带上科技的温度，扫除生活劳累，让生活舒适加倍。",
    ],
  },
  honor: [
    {
      imgurl: require("@/assets/images/honor1.png"),
    },
    {
      imgurl: require("@/assets/images/honor2.png"),
    },
    {
      imgurl: require("@/assets/images/honor3.png"),
    },
    {
      imgurl: require("@/assets/images/honor4.png"),
    },
    {
      imgurl: require("@/assets/images/honor5.png"),
    },
  ],
};

// 联系方式
export const contact = {};
